import React, { useEffect } from "react";
import fastFood from "../../assets/newLogo.jpeg";
import Footer from "../../components/Footer/Footer";
import styles from "./MyDeliveries.module.css";
import { Link } from "react-router-dom";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../redux/actions/orderActions";

const MyDeliveries = () => {
  const allOrder = useSelector((state) => state.order);
  const { loading, orders, error } = allOrder;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrder());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <h1>My Deliveries</h1>
      </header>

      <main>
        <p className={styles.status}>Pending deliveries</p>

        {loading && (
          <h2 className={styles.status}>Loading Pending deliveries ...</h2>
        )}
        {error && <h2>{error}</h2>}
        {orders &&
          orders.map((order) => (
            <div key={order._id}>
              {order.status === "pending" && (
                <>
                  <Link to={`/track-delivery/${order._id}`}>
                    <div className={styles.card}>
                      <div className={styles.top}>
                        <img src={fastFood} alt="fast-food" />
                        <div className={styles.name}>
                          <h3>{order.typeOfOrder}</h3>
                          <small>
                            {moment(order.date).format("DD MMM YYYY, hh:mm a")}
                          </small>
                        </div>
                        <div className={styles.deliveryStatus}>
                          <h4>Picking in {order.pickMinutes} Min</h4>
                          <small>$ {order.payment_amount}</small>
                        </div>
                      </div>
                      <div className={styles.bottom}>
                        <p>{order.pickup.personName}</p>
                        <div className={styles.locationIcons}>
                          <i
                            className={styles.icon + " fas fa-map-marker-alt"}
                          ></i>
                          <span>......</span>
                          <i
                            className={styles.icon + " fas fa-location-arrow"}
                          ></i>
                        </div>
                        <p>{order.dropoff.personName}</p>
                      </div>
                    </div>
                  </Link>
                </>
              )}
            </div>
          ))}

        <p className={styles.status}>Past deliveries</p>

        {loading && (
          <h2 className={styles.status}>Loading Past deliveries ...</h2>
        )}
        {error && <h2>{error}</h2>}
        {orders &&
          orders.map((order) => (
            <div key={order._id}>
              {order.status === "accepted" && (
                <>
                  <div className={styles.card}>
                    <div className={styles.top}>
                      <img src={fastFood} alt="fast-food" />
                      <div className={styles.name}>
                        <h3>{order.typeOfOrder}</h3>
                        <small>
                          {" "}
                          {moment(order.date).format("DD MMM YYYY, hh:mm a")}
                        </small>
                      </div>
                      <div className={styles.deliveryStatus}>
                        <h4>Picking in {order.pickMinutes} Min</h4>
                        <small>$ {order.payment_amount}</small>
                      </div>
                    </div>
                    <div className={styles.bottom}>
                      <p>{order.pickup.personName}</p>
                      <div className={styles.locationIcons}>
                        <i
                          className={styles.icon + " fas fa-map-marker-alt"}
                        ></i>
                        <span>......</span>
                        <i
                          className={styles.icon + " fas fa-location-arrow"}
                        ></i>
                      </div>
                      <p>{order.dropoff.personName}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
      </main>
      <Footer />
    </div>
  );
};

export default MyDeliveries;
